import "./src/styles/global.css";
import Wrapper from "./src/wrapper";
export const wrapPageElement = Wrapper;